import { Container } from '@mui/material';
import _ from 'lodash';
import React from 'react';

import { iconNames } from '@/components/icons';
import { ScreenReaderOnly } from '@/components/screen-reader-only';

import ChipsForFilters from './chips-for-filters';
import { Filter, FilterButtonWrapper, Filters, Divider, FilterHeader, SelectionPanel, StyledIcon } from './styles';

const DiscoveryFilterTabletDesktop = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'uiSelectedPriceRange' implicitly has an 'any' type.
  uiSelectedPriceRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'reset' implicitly has an 'any' type.
  reset,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'resetSelectedPriceRange' implicitly has an 'any' type.
  resetSelectedPriceRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filterConfig' implicitly has an 'any' type.
  filterConfig,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'currentlyOpenFilter' implicitly has an 'any' type.
  currentlyOpenFilter,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'safetyFeatures' implicitly has an 'any' type.
  safetyFeatures,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'toggleCurrentlyOpenFilter' implicitly has an 'any' type.
  toggleCurrentlyOpenFilter,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filterState' implicitly has an 'any' type.
  filterState,
}) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'fieldId' implicitly has an 'any' type.
  const onClick = (fieldId) => toggleCurrentlyOpenFilter(fieldId);

  return (
    <>
      <FilterHeader>
        <Container maxWidth="xl">
          <Filters>
            {_.map(filterConfig, (field) => (
              <Filter
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element; isOpen: boolean; onClick: () => any; key: any; onKeyDown: (event: KeyboardEvent<HTMLLIElement>) => void; }' is not assignable to type 'IntrinsicAttributes & { theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<...> & LiHTMLAttributes<...>'.
                isOpen={currentlyOpenFilter === field.id}
                onClick={() => onClick(field.id)}
                key={field.id}
                onKeyDown={(event) => {
                  if (event.key === ' ') {
                    event.preventDefault();
                    onClick(field.id);
                  }
                }}
              >
                <FilterButtonWrapper role="button" aria-expanded={field.id === currentlyOpenFilter} tabIndex={0}>
                  {field.name}
                  <ScreenReaderOnly>- expands below this list</ScreenReaderOnly>
                  {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ isOpen: boolean; name: "filter" | "visibility" | "caret" | "download" | "close" | "compareCar" | "cross" | "expand" | "didYouKnow" | "facebook" | "hamburger" | "instagram" | "linkActive" | ... 12 more ... | "warning"; }' is not assignable to type 'IntrinsicAttributes & IconProps & { theme?: Theme | undefined; }'. */}
                  <StyledIcon isOpen={currentlyOpenFilter === field.id} name={iconNames.expand} />
                </FilterButtonWrapper>
              </Filter>
            ))}
          </Filters>
          {currentlyOpenFilter && <Divider />}
        </Container>
      </FilterHeader>

      {_.map(filterConfig, ({ content, id }) => (
        <SelectionPanel hidden={currentlyOpenFilter !== id} key={id}>
          <Container maxWidth="xl">{content()}</Container>
        </SelectionPanel>
      ))}
      <Container maxWidth="xl">
        <ChipsForFilters
          {...{
            uiSelectedPriceRange,
            reset,
            resetSelectedPriceRange,
            filterConfig,
            safetyFeatures,
            displayClearLink: true,
            filterState,
          }}
        />
      </Container>
    </>
  );
};

export default DiscoveryFilterTabletDesktop;
